import { encodeURL } from "@/utils/index";

export const EDIT_LIST = {
  general: [
    "Pale yellow wedding guest dress",
    "Light yellow wedding guest dress",
    "Pastel yellow wedding guest dress",
    "Bright yellow wedding guest dress",
    "Neon yellow wedding guest dress",
    "Yellow wedding guest dress",
    "Pale blue wedding guest dress",
    "Light blue wedding guest dress",
    "Pastel blue wedding guest dress",
    "Bright blue wedding guest dress",
    "Blue wedding guest dress",
    "Aqua blue wedding guest dress",
    "Baby blue wedding guest dress",
    "Royal blue wedding guest dress",
    "Cobalt blue wedding guest dress",
    "Pale pink wedding guest dress",
    "Light pink wedding guest dress",
    "Pastel pink wedding guest dress",
    "Bright pink wedding guest dress",
    "Neon pink wedding guest dress",
    "pink wedding guest dress",
    "Baby pink wedding guest dress",
    "Hot pink wedding guest dress",
    "Fuchsia pink wedding guest dress",
    "Dusty rose wedding guest dress",
    "Magenta wedding guest dress",
    "Lavender wedding guest dress",
    "Lilac wedding guest dress",
    "Mauve wedding guest dress",
    "Plum wedding guest dress",
    "Periwinkle wedding guest dress",
    "Pale green wedding guest dress",
    "Light green wedding guest dress",
    "Pastel green wedding guest dress",
    "Bright green wedding guest dress",
    "Neon green wedding guest dress",
    "green wedding guest dress",
    "Turquoise wedding guest dress",
    "Emerald wedding guest dress",
    "Army green wedding guest dress",
    "Teal wedding guest dress",
    "Mint green wedding guest dress",
    "Sage green wedding guest dress",
    "Forest green wedding guest dress",
    "Pale orange wedding guest dress",
    "Light orange wedding guest dress",
    "Pastel orange wedding guest dress",
    "Bright orange wedding guest dress",
    "Neon orange wedding guest dress",
    "orange wedding guest dress",
    "Pale purple wedding guest dress",
    "Light purple wedding guest dress",
    "Pastel purple wedding guest dress",
    "Bright purple wedding guest dress",
    "Neon purple wedding guest dress",
    "purple wedding guest dress",
    "Black wedding guest dress",
    "Blush wedding guest dress",
    "Navy wedding guest dress",
    "Grey wedding guest dress",
    "Red wedding guest dress",
    "Gold wedding guest dress",
    "Silver wedding guest dress",
    "Rose gold wedding guest dress",
    "Peach wedding guest dress",
    "Burgundy wedding guest dress",
    "Crimson wedding guest dress",
    "Poppy red wedding guest dress",
    "Salmon wedding guest dress",
    "Mango wedding guest dress",
    "Coral wedding guest dress",
    "Elegant wedding guest dress",
    "Boho wedding guest dress",
    "Formal wedding guest dress",
    "Simple wedding guest dress",
    "Classic wedding guest dress",
    "Romantic wedding guest dress",
    "Vintage-inspired wedding guest dress",
    "Modern wedding guest dress",
    "Modest wedding guest dress",
    "Glamorous wedding guest dress",
    "Minimalist wedding guest dress",
    "Chic wedding guest dress",
    "Affordable wedding guest dress",
    "Designer wedding guest dress",
    "Sustainable wedding guest dress",
    "Luxury wedding guest dress",
    "Casual wedding guest dress",
    "Beach wedding guest dress",
    "Rustic wedding guest dress",
    "Garden wedding guest dress",
    "Destination wedding guest dress",
    "Petite wedding guest dress",
    "Plus-size wedding guest dress",
    "Short wedding guest dress",
    "Long wedding guest dress",
    "Maxi wedding guest dress",
    "A-line wedding guest dress",
    "Fit-and-flare wedding guest dress",
    "Off-the-shoulder wedding guest dress",
    "Strapless wedding guest dress",
    "Sleeveless wedding guest dress",
    "Halter wedding guest dress",
    "Cap sleeve wedding guest dress",
    "V-neck wedding guest dress",
    "One-shoulder wedding guest dress",
    "High-neck wedding guest dress",
    "Lace wedding guest dress",
    "Satin wedding guest dress",
    "Velvet wedding guest dress",
    "Chiffon wedding guest dress",
    "Tulle wedding guest dress",
    "Sequin wedding guest dress",
    "Embroidered wedding guest dress",
    "Backless wedding guest dress",
    "Wrap wedding guest dress",
    "Floral wedding guest dress",
    "Polka dot wedding guest dress",
    "Colorful wedding guest dress",
    "Pastel wedding guest dress",
    "Bold wedding guest dress",
    "Pale yellow bridesmaid dress",
    "Light yellow bridesmaid dress",
    "Pastel yellow bridesmaid dress",
    "Bright yellow bridesmaid dress",
    "Neon yellow bridesmaid dress",
    "Yellow bridesmaid dress",
    "Pale blue bridesmaid dress",
    "Light blue bridesmaid dress",
    "Pastel blue bridesmaid dress",
    "Bright blue bridesmaid dress",
    "Blue bridesmaid dress",
    "Aqua blue bridesmaid dress",
    "Baby blue bridesmaid dress",
    "Royal blue bridesmaid dress",
    "Cobalt blue bridesmaid dress",
    "Pale pink bridesmaid dress",
    "Light pink bridesmaid dress",
    "Pastel pink bridesmaid dress",
    "Bright pink bridesmaid dress",
    "Neon pink bridesmaid dress",
    "pink bridesmaid dress",
    "Baby pink bridesmaid dress",
    "Hot pink bridesmaid dress",
    "Fuchsia pink bridesmaid dress",
    "Dusty rose bridesmaid dress",
    "Magenta bridesmaid dress",
    "Lavender bridesmaid dress",
    "Lilac bridesmaid dress",
    "Mauve bridesmaid dress",
    "Plum bridesmaid dress",
    "Periwinkle bridesmaid dress",
    "Pale green bridesmaid dress",
    "Light green bridesmaid dress",
    "Pastel green bridesmaid dress",
    "Bright green bridesmaid dress",
    "Neon green bridesmaid dress",
    "green bridesmaid dress",
    "Turquoise bridesmaid dress",
    "Emerald bridesmaid dress",
    "Army green bridesmaid dress",
    "Teal bridesmaid dress",
    "Mint green bridesmaid dress",
    "Sage green bridesmaid dress",
    "Forest green bridesmaid dress",
    "Pale orange bridesmaid dress",
    "Light orange bridesmaid dress",
    "Pastel orange bridesmaid dress",
    "Bright orange bridesmaid dress",
    "Neon orange bridesmaid dress",
    "orange bridesmaid dress",
    "Pale purple bridesmaid dress",
    "Light purple bridesmaid dress",
    "Pastel purple bridesmaid dress",
    "Bright purple bridesmaid dress",
    "Neon purple bridesmaid dress",
    "purple bridesmaid dress",
    "Black bridesmaid dress",
    "Blush bridesmaid dress",
    "Navy bridesmaid dress",
    "Grey bridesmaid dress",
    "Red bridesmaid dress",
    "Gold bridesmaid dress",
    "Silver bridesmaid dress",
    "Rose gold bridesmaid dress",
    "Peach bridesmaid dress",
    "Burgundy bridesmaid dress",
    "Crimson bridesmaid dress",
    "Poppy red bridesmaid dress",
    "Salmon bridesmaid dress",
    "Mango bridesmaid dress",
    "Coral bridesmaid dress",
    "Elegant bridesmaid dresses",
    "Boho bridesmaid dresses",
    "Formal bridesmaid dresses",
    "Simple bridesmaid dresses",
    "Classic bridesmaid dresses",
    "Romantic bridesmaid dresses",
    "Vintage-inspired bridesmaid dresses",
    "Modern bridesmaid dresses",
    "Modest bridesmaid dresses",
    "Glamorous bridesmaid dresses",
    "Minimalist bridesmaid dresses",
    "Chic bridesmaid dresses",
    "Affordable bridesmaid dresses",
    "Designer bridesmaid dresses",
    "Sustainable bridesmaid dresses",
    "Luxury bridesmaid dresses",
    "Casual bridesmaid dresses",
    "Beach bridesmaid dresses",
    "Rustic bridesmaid dresses",
    "Garden wedding bridesmaid dresses",
    "Destination wedding bridesmaid dresses",
    "Maternity bridesmaid dresses",
    "Petite bridesmaid dresses",
    "Plus-size bridesmaid dresses",
    "Short bridesmaid dresses",
    "Long bridesmaid dresses",
    "Floor-length bridesmaid dresses",
    "Maxi bridesmaid dresses",
    "A-line bridesmaid dresses",
    "Mermaid bridesmaid dresses",
    "Fit-and-flare bridesmaid dresses",
    "Off-the-shoulder bridesmaid dresses",
    "Strapless bridesmaid dresses",
    "Sleeveless bridesmaid dresses",
    "Halter bridesmaid dresses",
    "Cap sleeve bridesmaid dresses",
    "V-neck bridesmaid dresses",
    "One-shoulder bridesmaid dresses",
    "High-neck bridesmaid dresses",
    "Lace bridesmaid dresses",
    "Satin bridesmaid dresses",
    "Velvet bridesmaid dresses",
    "Chiffon bridesmaid dresses",
    "Tulle bridesmaid dresses",
    "Sequin bridesmaid dresses",
    "Embroidered bridesmaid dresses",
    "Backless bridesmaid dresses",
    "Wrap bridesmaid dresses",
    "Convertible bridesmaid dresses",
    "Multiway bridesmaid dresses",
    "wedding guest dresses that feel chic, elevated and timeless",
    "chic dresses for euro summer",
    "wedding guest dress for a formal beach wedding",
    "bridal dresses",
    "outfit I'd wear in spring in Paris",
    "chic gowns for a gala in the city",
    "apres ski mode",
    "butter yellow pieces",
    "dresses or tops for easter",
    "dresses to wear for a desert-themed party",
    "outfits for festivals",
    "elegant dresses for a night out",
    "What should I wear for a wedding in Aspen in the fall?",
    "What should I wear to a dinner at Annabel’s London, in april",
    "What type of pants can take me from the plane to a business meeting?",
    "What should I wear to a trip to Egypt in March?",
    "What should I wear for a NYC wedding in winter?",
  ],
  item: [
    // Categories
    "dresses",
    "tops",
    "outerwear",
    "jeans",
    "jumpsuits & rompers",
    "pants",
    "skirts",
    "shorts",
    "sweaters & knits",
    "shoes",
    "heels",
    "flats",
    "boots",
    "ballet flats",
    "loafers",
    "mules",
    "sandals",
    "sneakers",
    "the capsule closet",
    "quiet luxury staples",
    "denim on denim",
    "sporty luxe",
    "resort essentials",
    "office attire",
    // Home Cards
    "pastel colored long-sleeve blouses with ruffle details, size small",
    "Silk dresses with lace details, no cutout or slits",
    "Versatile midi summer dress, sleek with a fitted waist, no patterns",
    "Blazer with cinched waist in neutral colors, on sale, under $500",
    "what kind of work dresses are good for a rectangle body type?",
    "What do I wear for a wedding in Jackson Hole in May? Under $500",
    "What type of jackets are chic and warm for date nights in San Francisco?",
    "What should I wear to my rehearsal dinner as the bride on the Amalfi Coast?",
  ],
};

export const searchResultRoute = (search: string) => {
  if (EDIT_LIST.general.includes(search) || EDIT_LIST.item.includes(search)) {
    return `/edits/${encodeURL(search)}`;
  } else {
    return `/results/${encodeURL(search)}`;
  }
};
